<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__rdaccountdailystat}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-input v-model="dataForm.materialId" placeholder="素材id" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="dataForm.materialName" placeholder="素材名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-input v-model="dataForm.productType" placeholder="素材名称" clearable></el-input> -->
          <!-- <renSelect
            v-model="dataForm.productType"
            dictType="loan_type"
            placeholder="项目"
          ></renSelect> -->
          <el-select v-model="dataForm.productType" placeholder="项目">
            <el-option v-for="item in productTypeList" :key="item.value" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>

          
          <el-form-item>
            <!-- <el-select style="width:150px;margin-right: 1px;" v-model="dataForm.dateText" filterable clearable placeholder="日期范围">
                  <el-option
                          v-for="item in dateList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select> -->
            <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="getTimes">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="getList()">{{ $t('query') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item> -->
  <!--        <el-form-item>-->
  <!--          <el-button v-if="$hasPermission('demo:rdaccountdailystat:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
  <!--        </el-form-item>-->
  <!--        <el-form-item>-->
  <!--          <el-button v-if="$hasPermission('demo:rdaccountdailystat:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
  <!--        </el-form-item>-->
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border @sort-change="dataListSortChangeHandle($event,true)"  style="width: 100%;">
          <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
          
          
          <el-table-column prop="statDatetime" label="日期" header-align="center" align="center"></el-table-column>
          <el-table-column prop="materialId" label="素材id" header-align="center" align="center"></el-table-column>
          <el-table-column prop="productType" label="项目" header-align="center" align="center"></el-table-column>
          <el-table-column prop="materialName" label="视频名称" header-align="center" align="center"></el-table-column>
          <!-- <el-table-column prop="materialPicUrl" label="视频图片" header-align="center" align="center">
            <template slot-scope="scope">
             
            </template>
          </el-table-column> -->
          <el-table-column prop="materialUrl" label="素材" width="180PX" header-align="center" align="center">
            <template slot-scope="scope">
              <div  @mouseenter="enterImg(scope.row.materialId)" @mouseleave="outImg(scope.row.materialId)">
                <img v-if="!scope.row.myishsow" class="vimg" :src="scope.row.materialPicUrl" alt="">
                <video-play v-else :src="scope.row.materialUrl"></video-play>
              </div>
             
            </template>
          </el-table-column>
        
          <el-table-column prop="cost" label="消耗" sortable="custom" header-align="center" align="center"></el-table-column>
          <el-table-column prop="convert" label="转化量" width="100" sortable="custom" header-align="center" align="center"></el-table-column>
          <el-table-column prop="convertCost" label="转化成本" width="150" sortable="custom"  header-align="center" align="center"></el-table-column>
          <el-table-column prop="convertRate" label="转化率" width="100" sortable="custom"  header-align="center" align="center"></el-table-column>
          
         <el-table-column prop="playDuration3sRate" width="150" sortable="custom" label="3S完播率" header-align="center" align="center"></el-table-column>
         <el-table-column prop="playDuration5sRate" width="150" sortable="custom" label="5S完播率" header-align="center" align="center"></el-table-column>
         <el-table-column prop="playDuration" label="播放量" header-align="center" align="center"></el-table-column>
         <el-table-column prop="playOverRate" label="播放率" header-align="center" align="center"></el-table-column>
         <el-table-column prop="playOverRate" label="有效播放成本" header-align="center" align="center"></el-table-column>
         <el-table-column prop="averagePlayTimePerPlay" label="平均单次播放时长" header-align="center" align="center"></el-table-column>
         <el-table-column prop="show" label="展示数" header-align="center" align="center"></el-table-column>
         <el-table-column prop="click" label="点击数" header-align="center" align="center"></el-table-column>
         <el-table-column prop="ctr" label="点击率" header-align="center" align="center"></el-table-column>
  
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './advertising-add-or-update'
  import videoPlay from '@/components/video-play.vue'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/report/videoPage',
          getDataListIsPage: true,
          exportURL: '/sys/report/export',
          deleteURL: '/sys/report',
          deleteIsBatch: true ,
        },
        isImg: true,
        dateList:[
            {
                label: '分日',
                value: '0',
            },
            {
                label: '分周',
                value: '1',
            },
            {
                label: '合计',
                value: '2',
            },
        ],
        productTypeList: [],
        date:'',
       
        dataForm: {
          id: '',
          materialId:'',
          startDate:'',
          endDate:'',
          dateText:'',
          productType: '',
        }
      }
    },
    components: {
      AddOrUpdate,
      videoPlay
    },
    mounted(){
      this.getproductTypeList()
    },
    methods: {
      enterImg(v){
        let n = this.dataList.findIndex(item => item.materialId == v)
        this.$set(this.dataList,n,{...this.dataList[n],myishsow:  true})
      },
      outImg(v){
        let n = this.dataList.findIndex(item => item.materialId == v)
        this.$set(this.dataList,n,{...this.dataList[n],myishsow: false})
        
      },

      //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
      //⽀付时间戳设置
      getTimes() {
        if (this.date != null) {
          this.dataForm.startDate = this.date[0]
          this.dataForm.endDate = this.date[1]
        }else{
          delete this.dataForm.startDate 
          delete this.dataForm.endDate
        }
      },
      getproductTypeList() {
          this.$http.get(`/sys/dict/data/list?dataType=loan_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.productTypeList = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                    this.productTypeList.push({label: element.dictLabel ,value: element.dictLabel})
                  })
              }
          }).catch(() => {})
      },
      getList(){
        this.getDataList()
      }
    }
  }
  </script>
<style>
.vimg{
  /* display: block; */
  width: 100%;
  height: 150px;
}

</style>
  